const {  exec } = require('child_process');
export default class CardSocketClient {
    constructor() {
        this.url = 'ws://127.0.0.1:24012/';
        this.socket = null;
        this.dataCallback = null; //读取到了身份证信息
        this.snrCallback = null; //读取到了身份证的编号
        this.codeCallback = null;//设备当前code发生变化
        this.errorCallback = null;//异常
        this.closeCallback = null; //服务连接失败
        this.isConnected = false; // socket连接状态标志
        this.msgid = 0
        this.timer = null
        this.pingTnterval = 1 * 1000
        this.Interval = null
        this.isconnect = false //读卡器是否连接成功
        this.samid = "" //5-13是4G, 另外判定为离线版
        this.resetTimeout = null
    }
    connect() {
        this.socket = new WebSocket(this.url);
        this.resetTimeout = setTimeout(async () => {
            await this.resetServer('ZKIDROnline_Server.exe')
            this.connect()
        }, 5 * 1000);
        this.socket.onmessage = (event) => {
            const res = JSON.parse(event.data);
            // console.log(res, '第一时间数据')
            const CODE = this.msgid === '5-13' ? this.CODE4G : this.CODE
            const index = CODE.findIndex(v => v.code == res.ret)
            const statusData = { ...CODE[index], ...res }
            if (res.ret == 0) {
                //心跳
                if (!!res.data && res.data.samid) {
                    this.samid = res.data.samid.substr(0, 4)
                    // console.log(this.samid)
                    this.pingpong()
                    if (this.isconnect == false) {
                        this.send({
                            module: "idcard", msgid: "123456789", function: "beginreadcard"
                        })
                        this.isconnect = true
                        if (this.codeCallback) {
                            this.codeCallback({ isconnect: this.isconnect, ...statusData })
                        }
                    }

                }
                if (res.event == 'onreadcard' && res.ret == 0) {
                    if (this.dataCallback) {
                        this.dataCallback(res.Certificate)
                    }
                }
            } else {
                if (res.ret == 1) {
                    //没有连接设备
                    this.isconnect = false
                    if (this.codeCallback) {
                        this.codeCallback({ isconnect: this.isconnect, ...statusData })
                    }
                } else {
                    //其他走异常
                    if (this.errorCallback) this.errorCallback(statusData)
                }
                this.pingpong()
            }
        };
        this.socket.onopen = () => {
            clearTimeout(this.resetTimeout)
            console.log('WebSocket连接已建立');
            this.isConnected = true; // 连接成功后设置连接状态为 true
            this.sendPing()
        };
        this.socket.onclose = (e) => {
            console.log('WebSocket连接已关闭');
            this.isConnected = false; // 连接关闭后设置连接状态为 false
            console.log(e)
            if (this.socket) {
                this.closeCallback(e)
            }
        };
        this.socket.onerror = (error) => {
            console.error('WebSocket错误:', error);
            // 处理连接错误
        };
    }

    setDataCallback(callback) {
        this.dataCallback = callback;
    }
    setErrorCallback(callback) {
        this.errorCallback = callback;
    }
    setSnrCallback(callback) {
        this.snrCallback = callback;
    }
    setCodeCallback(callback) {
        this.codeCallback = callback
    }
    setCloseCallback(callback) {
        this.closeCallback = callback
    }
    sendPing() {
        this.send({
            function: 'getsam',
            module: "idcard",
            msgid: this.msgid + '',
            parameter: {
                dev: '1'
            }
        })
    }
    pingpong() {
        clearTimeout(this.Interval)
        this.Interval = setTimeout(() => {
            this.msgid += 1
            try {
                this.sendPing()
            } catch (e) {
                console.log(e)
            }
        }, this.pingTnterval);
    }
    send(message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify({
                ...message,
                msgid: this.msgid + ''
            }));
        } else {
            console.error('WebSocket连接未建立或已关闭');
        }
    }
    close() {
        if (this.socket) {
            this.socket.close();
            this.socket = null
        }
    }

    CODE = [{
        code: 0,
        msg: '成功'
    },
    {
        code: 1,
        msg: '端口打开失败'
    },
    {
        code: 2,
        msg: '数据传输超时'
    },
    {
        code: 3,
        msg: '设置超时时间失败'
    },
    {
        code: 4,
        msg: '设备忙打开失败'
    },
    {
        code: 6,
        msg: '接口地址参数有误'
    }, {
        code: 10,
        msg: '没有找到卡'
    }, {
        code: 11,
        msg: '读卡失败'
    }, {
        code: 20,
        msg: '自检失败'
    }, {
        code: 30,
        msg: '其他错误'
    }, {
        code: 40,
        msg: '相片解码失败'
    }, {
        code: 100,
        msg: '超时'
    }, {
        code: 200,
        msg: '获取照片Base64失败'
    }, {
        code: 201,
        msg: '操作失败'
    }, {
        code: 202,
        msg: 'IC卡参数出错'
    }]

    CODE4G = [{
        code: 0,
        msg: '成功'
    },
    {
        code: 1,
        msg: '输入参数错误'
    },
    {
        code: 2,
        msg: '设备不存在（比如阅读器未连接）'
    },
    {
        code: 3,
        msg: '找卡失败'
    },
    {
        code: 4,
        msg: '该功能不支持'
    },
    {
        code: 5,
        msg: '选卡失败'
    },
    {
        code: 6,
        msg: '读卡失败'
    }, {
        code: 7,
        msg: '写卡失败'
    }, {
        code: 8,
        msg: '卡片数据格式错误'
    }, {
        code: 10,
        msg: '10'
    }, {
        code: 11,
        msg: '图片解码库加载失败'
    }, {
        code: 12,
        msg: 'BMP转JPG函数缺失'
    }, {
        code: 14,
        msg: '临时目录写失败'
    }, {
        code: 15,
        msg: 'WLT解码BMP失败'
    }, {
        code: 16,
        msg: '临时目录读失败'
    }, {
        code: 17,
        msg: 'BMP编码JPG失败'
    }, {
        code: 18,
        msg: 'JPG图片BASE64编码失败'
    }, {
        code: 19,
        msg: 'BMP图片BASE64编码失败'
    }, {
        code: 20,
        msg: 'URL解码失败'
    }, {
        code: 22,
        msg: '写入数据超过限制'
    }, {
        code: '其他',
        msg: '未知错误'
    }]

    // 重启服务的函数
    resetServer(serviceName) {
        return new Promise((resolve, reject) => {
            // 停止服务
            exec(`net stop ${serviceName}`, (error, stdout, stderr) => {
                if (error) {
                    console.error(`停止服务时出错：${error.message}`);
                    return reject()
                }

                // 启动服务
                exec(`net start ${serviceName}`, (error, stdout, stderr) => {
                    if (error) {
                        console.error(`启动服务时出错：${error.message}`);
                        return reject()
                    }

                    console.log(`${serviceName} 服务已成功重启`);
                    resolve()
                });
            });
        })
    }
}